import { useParams } from "react-router-dom";
import CustomForm from '../Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../Util/Form/CustomForm/CustomFormContainer';
import Toast from "../Util/Toast/Toast";

function Form() {
    const { id } = useParams();

    let path = '/core/examples/crud/frontend/';
    const paths = {
        urlGoBack: path+'list',
        pathView: path+'view',
    }

    const labels = {
        labelTitleAdd:  "Nova Empresa",
        labelTitleEdit: "Editar Empresa",
        labelTitleView: 'Visualizar Empresa'
    }

    const form = {
        validateOnChange: true,
        handleSubmit: (form,values) => {
            Toast.success('Formulário atualizado com sucesso!');
        },
        fields: [
            {
                name: 'label-teste',
                type: 'label',
                label: 'Label',
                value: <p>oi</p>     
            },
            {
                name: 'text_teste',
                type: 'text',
                label: 'Text',
                validations: {
                    required: true
                },
                columnSize: 6
            },
            {
                name: 'email_teste',
                type: 'email',
                label: 'Email',
                validations: {
                    required: true
                },
                columnSize: 6
            },
            {
                name: 'telefone_teste',
                type: 'phone',
                label: 'Telefone2',
                validations: {
                    required: true
                },
                columnSize: 4
            }, 
            {
                name: 'senha_teste',
                type: 'password',
                label: 'Senha',
                validations: {
                    required: true
                },
                columnSize: 4
            },
            {
                name: 'cnpj_teste',
                type: 'CNPJ',
                label: 'CNPJ',
                validations: {
                    required: true
                },
                columnSize: 4
            },
            {
                name: 'select_teste',
                type: 'select',
                label: 'Select Teste',
                options: [
                    {label: 'item 1',value:1},
                    {label: 'item 2',value:2},
                ],
                validations: {
                    required: true
                },
                columnSize: 12
            },
            {
                name: 'date',
                type: 'date',
                label: 'Date',
                validations: {
                    required: true
                },
                columnSize: 6
            },
            {
                name: 'time',
                type: 'time',
                label: 'Hora',
                validations: {
                    required: true
                },
                columnSize: 6
            }, 
            {
                name: 'endereco',
                type: 'address',
                label: 'Endereço',
                value: {
                    address_number: "291",
                    city: "Jundiaí",
                    country: "Brasil",
                    district: "Centro",
                    state: "SP",
                    street_name: "Rua Vigário João José Rodrigues",
                    zipcode: "13201-001"
                },
                validations: {
                    required: true
                }
            },
            {
                name: 'textarea_teste',
                type: 'textarea',
                label: 'Text Area',
                validations: {
                    required: true
                }
            },
            {
                name: 'check',
                type: 'checkbox',
                label: 'Checkbox',
                validations: {
                    required: true
                },
                columnSize: 12
            },       
        ],
        ...paths,
        ...labels
    }

    if(id){
        form.values = {
            text_teste: 2,
            email_teste: 'diego@teste.com.br',
            telefone_teste: '11984304055',
            senha_teste: '123',
            textarea_teste: '234234',
            cnpj_teste: '99.184.178/0001-05',
            select_teste: 2,
            date: '2022-06-22',
            time: '10:00',
            check: '1',
            endereco: {
                address_number: "291",
                city: "Jundiaí",
                country: "Brasil",
                district: "Centro",
                state: "SP",
                street_name: "Rua Vigário João José Rodrigues",
                zipcode: "13201-001"
            }
        } 
    }

    return (
        <div>
            <CustomFormContainer 
                form = {form}
                content    = {<CustomForm form={form} />}
            />
        </div>
    );
}
export default Form;
